import { useState, useEffect } from 'react'
import { buildLocalDateTime, formatLocalDateInput } from '../utilities/dateUtils';

export const useExclusiveHours = (appointmentHours, hours, date) => {

  const [exclusiveHours, setExclusiveHours] = useState([]);

  // console.log(hours)
  useEffect(() => {
    if (Array.isArray(hours)) {
      const occupiedHours = Array.isArray(appointmentHours) ? appointmentHours : [];
      let hoursFiltered = hours.filter(ele => !occupiedHours.includes(ele))

      if (date === formatLocalDateInput()) {
        const now = new Date().getTime();

        hoursFiltered = hoursFiltered.filter(ele => {
          const dateTime = buildLocalDateTime(date, ele);

          return dateTime && dateTime.getTime() > now;
        })
        setExclusiveHours(hoursFiltered)
      } else {
        setExclusiveHours(hoursFiltered);
      }
    } else {
      setExclusiveHours([]);
    }

  }, [appointmentHours, hours, date])

  return { exclusiveHours }

}
